import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'cc-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrls: ['./dropdown-input.component.scss']
})
export class DropdownInputComponent implements OnInit, OnDestroy {
  @Input() elements: string[];
  @Input() formControl: FormControl;

  searchInputControl: FormControl;
  filteredElements: Observable<string[]>;

  private _onDestroy = new Subject<void>();

  constructor() {}

  ngOnInit() {
    this.searchInputControl = new FormControl(this.formControl.value);

    this.searchInputControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filter(this.searchInputControl.value);
    });

    this.filteredElements = this.searchInputControl.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.filter(value))
    );
  }

  filter(value: string) {
    const filterValue = value.toLowerCase();
    return this.elements.filter(option => option.toLowerCase().includes(filterValue));
  }

    ngOnDestroy(): void {
      this._onDestroy.next();
      this._onDestroy.complete();
    }
}
